export default __webpack_public_path__ + "static/media/icon-link-accent2.d831b78e.svg";